<template>
  <div>
    <!-- mark as active -->

    <ElButton
      v-if="
        flight?.assets?.length > 0 &&
        flight?.can_mark_as_active &&
        $canAccess(['traffic-manager']) &&
        !$is_PM &&
        !$is_GD &&
        $SBCampaignStatusAccess(['ready_to_launch', 'in_review'], flightStatus)
      "
      type="primary"
      class="mark-as-active-btn"
      @click="markAsActive"
    >
      Mark as Active
      <svg width="12" height="12" fill="none">
        <use :xlink:href="`#info-in-circle`"></use>
      </svg>
    </ElButton>

    <!-- In Review -->
    <template v-if="$SBCampaignStatusAccess(['new', 'in_review', 'revision'], flightStatus) && !$is_PM">
      <ElButton
        v-if="
          flight?.assets?.length > 0 && ($canAccess(['agency', 'agency-employee', 'employee']) || $isTopBrandAdmin()) && !$is_PM && !$is_GD
        "
        type="primary"
        :disabled="$SBCampaignStatusAccess(['in_review', 'revision'], flightStatus)"
        @click="sendToReview"
      >
        <i class="el-icon-position el-icon-left"></i> Send to review
      </ElButton>
    </template>
    <!-- end -->
    <!-- for PM -->
    <template v-if="$is_PM">
      <!-- in review status -->
      <template v-if="$SBCampaignStatusAccess(['in_review'], flightStatus)">
        <ElButton v-if="flight?.assets?.length > 0" type="primary" @click="requestRevision" plain>
          <i class="el-icon-top-left"></i> Request revision
        </ElButton>
        <ElButton v-if="flight?.assets?.length > 0" type="primary" @click="approve"> <i class="el-icon-check"></i> Approve </ElButton>
      </template>
      <!-- end in review -->
    </template>
    <!-- end -->
  </div>
</template>
<script>
import SendToReview from '@/components/social-products/social-boost/modal/SendToReview.vue'
import Approve from '@/components/social-products/social-boost/modal/Approve.vue'
import RequestRevision from '@/components/social-products/social-boost/modal/RequestRevision.vue'
import MarkAsActive from '@/components/social-products/social-boost/modal/MarkAsActive.vue'

export default {
  name: 'CtaHeaderActions',
  props: {
    campaign: {
      type: [Object, Boolean],
      default: false,
    },
    isFlightPage: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    flight() {
      return this.campaign?.flights?.find((f) => f.id === Number(this.$route.params.flight_id))
    },
    flightStatus() {
      return this.flight?.status
    },
  },
  methods: {
    sendToReview() {
      this.$Modal.init(
        {
          propsData: {
            component: SendToReview,
            meta: { campaign: this.campaign, flight: this.isFlightPage ? this.flight : false },
            size: '480px',
          },
          callback(payload) {
            if (payload.event === 'modal:close') {
              console.log('>>>>>')
            }
          },
        },
        this
      )
    },
    approve() {
      this.$Modal.init(
        {
          propsData: {
            component: Approve,
            meta: { campaign: this.campaign, flight: this.isFlightPage ? this.flight : false },
            size: '480px',
          },
          callback(payload) {
            if (payload.event === 'modal:close') {
              console.log('>>>>>')
            }
          },
        },
        this
      )
    },
    requestRevision() {
      this.$Modal.init(
        {
          propsData: {
            component: RequestRevision,
            meta: { campaign: this.campaign, flight: this.isFlightPage ? this.flight : false },
            size: '480px',
          },
          callback(payload) {
            if (payload.event === 'modal:close') {
              console.log('>>>>>')
            }
          },
        },
        this
      )
    },
    markAsActive() {
      this.$Modal.init(
        {
          propsData: {
            component: MarkAsActive,
            meta: { campaign: this.campaign, flight: this.isFlightPage ? this.flight : false },
            size: '480px',
          },
        },
        this
      )
    },
  },
}
</script>
<style lang="scss">
.mark-as-active-btn span {
  display: inline-flex;
  align-items: center;
  svg {
    margin-left: 8px;
  }
}
</style>
